import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { AlertBanner, AlertBannerState } from './types';

export const getters: GetterTree<AlertBannerState, RootState> = {
  getAlertBannerOptions(state): AlertBanner[] | undefined {
    return state.alertBannerOptions;
  },
};
